export enum ElitaRequestType{
    MULTIPART_POLICY = 'MULTIPART_POLICY',
    SIMPLE_POLICY = 'SIMPLE_POLICY'
}